// extracted by mini-css-extract-plugin
module.exports = {"root":"h_M","headline":"h_T","grid":"h_V","gridItem":"h_W","browseMoreNav":"h_X f_t"};